import { useProfileQuery } from "@/features/profile/api/selectProfile";
import OnboardingEmailForm from "@/features/onboarding/components/OnboardingEmailForm";
import { ProfileAttributePage, useProfileAttributePage } from "@/features/profile/components/ProfileAttributePage";
import { createFileRoute } from "@tanstack/react-router";

const Email = () => {
    const { auth, copy, goToProfile } = useProfileAttributePage();
    const { data: profile } = useProfileQuery();

    return (
        <ProfileAttributePage title={copy.onboardingEmailTitle} description={copy.onboardingEmailDescription}>
            <OnboardingEmailForm
                userId={auth.id}
                currentEmail={profile?.email ?? null}
                onBack={goToProfile}
                onSuccess={goToProfile}
                primaryLabel={copy.save}
            />
        </ProfileAttributePage>
    );
};

export const Route = createFileRoute("/_app/profile/email")({
    component: Email,
});
